













































import BaseLayout from "@/components/layout/BaseLayout.vue"
import {defineComponent, onUnmounted, reactive} from "@vue/composition-api"
import {ApplicationMetadata, getApplications} from "@/data/repos/environments"
import Loading from "@/components/Loading.vue"

export default defineComponent({
  components: {BaseLayout, Loading},
  setup() {
    const state = reactive({
      applications: [] as ApplicationMetadata[],
    })

    async function updateApplications() {
      state.applications = await getApplications()
    }

    updateApplications()
    const updateTimer = setInterval(() => updateApplications(), 30 * 1000)
    onUnmounted(() => clearInterval(updateTimer))
    return {state}
  },
})
